/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'CloudSlash': {
    width: 13,
    height: 12,
    viewBox: '0 0 13 12',
    data: '<path pid="0" d="M2.285 1.387l8.486 9.334M10.022 9.899c-.563.263-1.177.4-1.798.398H3.557a2.97 2.97 0 11.738-5.847M5.715 2.634a4.243 4.243 0 015.677 6.245M3.98 6.055A4.223 4.223 0 014.567 3.9" _stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
